<template>
  <div style="display: flex; flex-direction: column">
    <div style="display: flex; justify-content: space-between">
      <el-input
        v-model="cargoDoc.notifyCode"
        :disabled="disabled"
        style="flex:1"
      />
      <cargo-advance-select
        :disabled="disabled"
        :select-type="selectTypeNames.basic_data_Company"
        :method-params="{ notify: true, active: true }"
        filterable
        :default-value="cargoDoc.notifyId||''"
        style="flex:1"
        @parentCallBack="notifyAutoCompleteChange"
      />
    </div>
    <div style="margin-top: 5px">
      <el-button
        type="primary"
        :disabled="disabled"
        @click="onClear"
      >{{ $t('SeaExport.Reset') }}
      </el-button>
      <el-button
        type="primary"
        :disabled="disabled"
        style="margin-left: 5px"
        @click="onCopyConsignee(false)"
      >{{ $t('SeaExport.CopyTheConsignee') }}
      </el-button>
    </div>
    <cargo-input
      v-for="i in 7"
      :key="i"
      v-model="cargoDoc['notifyLine'+i]"
      :use-read-only="true"
      :disabled="disabled"
      :auto-uppercase="autoUppercase"
      :filter-chars="false"
      style="margin-top: 5px"
      @change="onChange('notifyLine'+i)"
      @dblclick.native="showAdvanceTextDialog($t('SeaExport.NotifyParty'),mergeNotifyLine(),splitNotifyLine,autoUppercase,{autoHalfWord:true,autoUppercase:autoUppercase})"
    />

    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="advanceTextDialog"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @close="closeAdvanceText"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        no="advanceTextDialogTextarea"
        :disabled="disabled"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :auto-uppercase="advanceTextDialog.formatObj.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button
          v-show="!disabled"
          no="advanceTextDialogConfirm"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="advanceTextDialogClose"
          @click="advanceTextDialog.visible=false;closeAdvanceText()"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>

    <div style="display: flex;">
      <el-select
        v-model="otherSelectField"
        :disabled="disabled"
        style="flex: 1"
      >
        <el-option
          v-for="(item,index) in otherFieldsData"
          :key="index"
          :label="item.englishName"
          :value="item.code"
        />
      </el-select>
      <cargo-advance-select
        v-if="otherSelectField==='ALSO NOTIFY'"
        :disabled="disabled"
        :allow-create="true"
        :select-type="selectTypeNames.basic_data_Company"
        :method-params="{ notify: true, active: true }"
        tag-name="englishName"
        tag-value="englishName"
        filterable
        style="flex: 1;margin-left: 5px;"
        :default-value="cargoDoc.alsoNotifyCode||''"
        @parentCallBack="alsoNotifyAutoCompleteChange"
      />
      <cargo-input
        v-if="otherSelectField==='DGCONSIGN'"
        v-model="cargoDoc.dgconsignCode"
        :disabled="disabled"
        :maxlength="otherFieldMaxChars"
        :auto-uppercase="autoUppercase"
        style="flex: 1;margin-left: 5px;"
      />
      <cargo-input
        v-if="otherSelectField==='ELSEINVOICE'"
        v-model="cargoDoc.elseInvoiceCode"
        :disabled="disabled"
        :maxlength="otherFieldMaxChars"
        :auto-uppercase="autoUppercase"
        style="flex: 1;margin-left: 5px;"
      />
    </div>
    <cargo-rich-textarea
      v-if="otherSelectField==='ALSO NOTIFY'"
      v-model="cargoDoc.alsoNotify"
      :disabled="disabled"
      :text-chars="0"
      wrap-symbol="r"
      auto-half-word
      :auto-uppercase="autoUppercase"
      style="height: 110px;margin-top: 5px;"
    />
  </div>
</template>

<script>
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import { Company } from '@/class/model/mdm/Company'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'

export default {
  name: 'SeMblNotify',
  components: { cargoInput, cargoAdvanceSelect, cargoRichTextarea },
  props: {
    cargoDoc: { type: Object, default: () => { return {} } },
    disabled: { type: Boolean, default: false },
    autoUppercase: { type: Boolean, default: false },
    otherFieldsData: { type: Array, default: () => [SeaExportConstants.ALSO_NOTIFY] },
    otherFieldMaxChars: { type: Number, default: 45 }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      otherSelectField: this.otherFieldsData && this.otherFieldsData.length > 0 ? this.otherFieldsData[0].code : '',
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0,
          autoHalfWord: false,
          autoUppercase: false
        }
      }
    }
  },
  watch: {
    otherFieldsData: {
      handler(newVal) {
        this.otherSelectField = newVal && newVal.length > 0 ? newVal[0].code : ''
      }
    }
  },
  methods: {
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.cargoDoc[key] }])
    },
    async notifyAutoCompleteChange(data) {
      const form = this.cargoDoc
      form.notifyId = data.value || 0
      if (data.value) {
        const company = new Company(data)
        await company.getMainfestAddress()
        CargoDocUtil.applyNotifyManifestAddress(form, data)
      } else {
        CargoDocUtil.onClear(form, 3)
      }
      this.changeAllItem(form)
    },
    onClear() {
      CargoDocUtil.onClear(this.cargoDoc, 3)
      this.changeAllItem(this.cargoDoc, ['notifyId'])
    },
    changeAllItem(form, ignoreKeys = []) {
      const items = []
      if (!ignoreKeys.includes('notifyCode')) {
        items.push({ key: 'notifyCode', value: form.notifyCode })
      }
      if (!ignoreKeys.includes('notifyId')) {
        items.push({ key: 'notifyId', value: form.notifyId })
      }
      for (let i = 1; i <= 7; i++) {
        if (!ignoreKeys.includes(`notifyLine${i}`)) {
          items.push({ key: `notifyLine${i}`, value: form[`notifyLine${i}`] })
        }
      }
      this.$emit('childrenChange', items)
    },
    // 抄录收货人
    onCopyConsignee(detail) {
      const form = this.cargoDoc
      form.notifyCode = form.consigneeCode
      form.notifyLine1 = form.consigneeLine1
      form.notifyLine2 = form.consigneeLine2
      form.notifyLine3 = form.consigneeLine3
      if (detail) {
        form.notifyCountry = form.consigneeCountry
        form.notifyCity = form.consigneeCity
        form.notifyProvince = form.consigneeProvince
        form.notifyZipCode = form.consigneeZipCode
        form.notifyMobile = form.consigneeMobile
        form.notifyEmail = form.consigneeEmail
        form.notifyFax = form.consigneeFax
        form.notifyContact = form.consigneeContact
      } else {
        form.notifyLine4 = form.consigneeLine4
        form.notifyLine5 = form.consigneeLine5
        form.notifyLine6 = form.consigneeLine6
        form.notifyLine7 = form.consigneeLine7
      }
      this.changeAllItem(form, ['notifyId'])
    },
    // 高级文本弹框相关方法
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0,
        autoHalfWord: false,
        autoUppercase: false
      }
      this.advanceTextDialog.formatObj = formatObject ? { ...defaultFormatObj, ...formatObject } : defaultFormatObj
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    closeAdvanceText() {
      // 关闭弹框时的清理工作
    },
    // 合并通知人地址行
    mergeNotifyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.cargoDoc['notifyLine' + i] || ''
        result += '\n'
      }
      result += (this.cargoDoc['notifyLine7'] || '')
      return result.trimEnd()
    },
    // 分割通知人地址行
    splitNotifyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.cargoDoc['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.cargoDoc['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.cargoDoc['notifyLine' + i] = ''
      }

      // 通知父组件数据变更
      this.changeAllItem(this.cargoDoc)
    },
    async alsoNotifyAutoCompleteChange(data) {
      if (!data) {
        return
      }
      if (data.value) {
        this.cargoDoc.alsoNotifyCode = data.value
        // 区分下是否手动输入 ，手动输入保留下面数据
        if (data.uuid) {
          const newAlsoNotify = await CargoDocUtil.alsoNotifyChange(data)
          if (newAlsoNotify) {
            this.cargoDoc.alsoNotify = newAlsoNotify
          }
        }
      } else {
        this.cargoDoc.alsoNotifyCode = ''
        // this.cargoDoc.alsoNotify = ''
      }
    }
  }
}
</script>
